module.exports = __webpack_public_path__ + "assets/global-e.4436026a.svg";